import React from 'react'
import s from './Odds.module.scss'
import {
    drizzleSegmentColorsPalette,
    segmentColorsPalette,
    SegmentColorType,
} from "../../../../types/Game";

const Odds: React.FC<IProps> = ({ segments, isDrizzlePartner }) => {
    const palette = isDrizzlePartner ? drizzleSegmentColorsPalette : segmentColorsPalette

    return (
        <div className="grid justify-center gap-2" style={{ gridTemplateColumns: `repeat(${segments.length}, 1fr)` }}>
            {segments.map(([color, odd], index) => {

                return (
                    <div className={s.item} key={index}>
                        <div
                            className={s.color}
                            key={index}
                            style={{
                                backgroundColor: palette[color],
                                // animationDelay: isTurboMode || !gameResult ? '0' : '3s',
                            }}
                        />
                        <span>{odd}</span>
                    </div>
                )
            })}
        </div>
    )
}

export default Odds

interface IProps {
    segments: Array<[SegmentColorType, number]>
    isDrizzlePartner: boolean
}